import React from "react";

/**
 * Sudeeshaa Solutions — brand logo
 *
 * Renders the official brand mark (tree emblem) from /public/img/logo.
 *   logo-mark-gold.png → circular emblem (used here, next to styled text)
 *   logo-full-gold.png → full artwork (for social / print use)
 *
 * `variant` and `uid` are accepted for backwards compatibility but unused.
 */
export const Logo = ({ uid = "sds", size = 42, variant = "orbit", showText = true, href = "#header" }) => {
  return (
    <a href={href} className="inline-flex items-center gap-3 group shrink-0" aria-label="Sudeeshaa Solutions">
      <span
        className="relative block transition-transform duration-300 group-hover:scale-105 group-hover:rotate-[-3deg]"
        style={{ width: size, height: size }}
      >
        <LogoMark size={size} />
      </span>

      {showText && (
        <span className="leading-none select-none">
          <span className="block font-display text-white text-[19px] md:text-[20px] tracking-[-0.01em]">
            Sudeeshaa
          </span>
          <span className="mt-[3px] flex items-center gap-1.5">
            <span className="h-[2px] w-3 rounded-full bg-gradient-to-r from-blue-400 to-violet-400" />
            <span className="text-[9.5px] font-extrabold tracking-[0.42em] text-blue-300/80">
              SOLUTIONS
            </span>
          </span>
        </span>
      )}
    </a>
  );
};

export const LogoMark = ({ uid = "sds", size = 42, variant = "orbit" }) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/img/logo/logo-mark-gold.png`}
      alt="Sudeeshaa Solutions logo"
      width={size}
      height={size}
      className="block rounded-full object-cover"
      draggable="false"
    />
  );
};
